var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { InputAdornment, makeStyles } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import Controls from "../common/controls/Controls";
import React from "react";
import styled from "styled-components";
var useStyles = makeStyles(function (theme) { return ({
    searchInput: {
        width: "85%",
        height: "48px",
        minWidth: "100px",
        backgroundColor: "#fff",
        marginRight: "10px",
        border: "1px solid #E4E4F0",
        borderRadius: "8px",
        "& .MuiInputLabel-outlined": {
            color: "#E4E4F0",
            fontSize: "12px",
            transform: "translate(14px, 18px) scale(1)",
        },
        "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
            transform: "translate(14px, -6px) scale(0.75)",
            display: "none",
        },
        "& .MuiOutlinedInput-inputAdornedEnd": {
            padding: "14.5px 14px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        },
    },
    searchIcon: {
        color: theme.palette.primary.main,
    },
}); });
var SearchInput = function (_a) {
    var className = _a.className, label = _a.label, handleSearch = _a.handleSearch;
    var classes = useStyles();
    var Input = Controls.Input;
    return (React.createElement(SearchInputBox, null,
        React.createElement(Input, { label: label ? label : "Search", size: "small", className: classes.searchInput + " " + className, InputProps: {
                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(Search, { className: classes.searchIcon }))),
            }, onChange: handleSearch })));
};
export default SearchInput;
var SearchInputBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map